
function addNewCartButton() {
    const eastoIframe = document.querySelector('iframe#bss-customer-portal');
    if (eastoIframe) {
        const checkoutContainer = document.querySelector('#radix-«r0» .easto-checkout-container');
        const buttonCheckout = document.querySelector('#radix-«r0» .easto-checkout-button');
        if (checkoutContainer && buttonCheckout) {
            const cloneButton = buttonCheckout.cloneNode();
            cloneButton.innerHTML = 'Proceed To Cart';
            cloneButton.addEventListener('click', () => {
                eastoIframe.contentWindow.postMessage({type: 'checkout', transactionId: 'easto-custom-event-open-cart', options: {ignoreClear: true}}, '*')
                cloneButton.disabled = true;
                cloneButton.style.opacity = 0.6
                setTimeout(() => {
                    cloneButton.disabled = false;
                    cloneButton.style.opacity = 1
                    window.location.href = '/cart'
                }, 1500);
            })
            
            buttonCheckout.style.display = "none"
            checkoutContainer.append(cloneButton);
        }
    }
}


document.addEventListener('DOMContentLoaded', ()=> {
    if (window.location.pathname.includes('/apps/subscription/box')  || document.querySelector('easto-portal-embed')) {
        const handleMessage = ((event) => {
        if (event.data.type === 'cart:open') {
            setTimeout(() => {
                
                addNewCartButton()
            }, 500);
        }
        });
        window.addEventListener('message', handleMessage);
    }
})


if (window?.BSS_SUB) {
    const styles = [
        {
        selector: '.box-card-progress, .vendor-name, #page-layout > div > button, .box-card > div.flex.justify-between.items-center.gap-3, .box-card .box-header',
        value: { display: 'none' },
        },
    ];
    window?.BSS_SUB?.custom?.addFilter('custom:global/custom-css', () => styles);
}